import React, { useRef, useEffect } from "react";
import { Box, Button, Typography } from "@mui/material";
import { SignatureCanvas } from "../SignaturePad/SignatureCanvas";

const SignatureField = ({ value, onChange, label = "Signature" }) => {
  const signatureRef = useRef();

  // Convert canvas dataURL to File
  const dataURLtoFile = (dataurl, filename) => {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) u8arr[n] = bstr.charCodeAt(n);
    return new File([u8arr], filename, { type: mime });
  };

  // Called whenever drawing ends (auto-save)
  const handleEndDrawing = () => {
    const dataURL = signatureRef.current.getSignature();
    if (dataURL) {
      const file = dataURLtoFile(dataURL, "signature.png");
      onChange(file);
    } else {
      onChange(null);
    }
  };

  // Clear signature
  const handleClear = () => {
    if (signatureRef.current) signatureRef.current.clear();
    onChange(null);
  };

  // Initialize existing value if it's a File or dataURL
  useEffect(() => {
    if (value && signatureRef.current) {
      const dataURL = value instanceof File ? URL.createObjectURL(value) : value;
      signatureRef.current.loadImage(dataURL); // <- safely load image on canvas
    }
  }, [value]);

  return (
    <Box sx={{ display: "flex", gap: 2, alignItems: "flex-start", mt: 1 }}>
      <Box sx={{ flex: 1 }}>
        <Typography variant="body2" fontWeight={600} sx={{ mb: 1 }}>
          {label}
        </Typography>
        <SignatureCanvas ref={signatureRef} onEndDrawing={handleEndDrawing} />
      </Box>

      <Button
        variant="outlined"
        color="secondary"
        onClick={handleClear}
        sx={{ height: "fit-content", mt: 4 }}
      >
        Clear
      </Button>
    </Box>
  );
};

export default SignatureField;